import { render, staticRenderFns } from "./HolidayPlusHotels.vue?vue&type=template&id=579f6ea6"
import script from "./HolidayPlusHotels.vue?vue&type=script&lang=js"
export * from "./HolidayPlusHotels.vue?vue&type=script&lang=js"
import style0 from "./HolidayPlusHotels.vue?vue&type=style&index=0&id=579f6ea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports